import { jsx as _jsx } from "react/jsx-runtime";
import { getLocationSuggestions } from "@/graphql/queries/LocationAutocomplete";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { SearchInput } from "../SearchAutocompleteInput";
import { SearchFormContext } from "../SearchFormContext";
export function LocationAutocompleteInput() {
    var _a = useContext(SearchFormContext), locationParamKey = _a.locationParamKey, locationValue = _a.locationValue, setLocationValue = _a.setLocationValue;
    return (_jsx(SearchInput, { label: "Search cities or type remote", paramKey: locationParamKey, value: locationValue, setValue: setLocationValue, gqlQuery: getLocationSuggestions, icon: _jsx(FontAwesomeIcon, { icon: faLocationDot }) }));
}
